export default __webpack_public_path__ + "static/media/unattemptedIcon.c93a9089.svg";